import { useNavigate } from "@tanstack/react-router";
import { toast } from "@devhop/ui";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCarriersQuery, useDeleteCarrier } from "../api/queries";
import { CarriersTable } from "../ui/CarriersTable";
import { CarriersToolbar } from "../ui/CarriersToolbar";

export function CarriersPage() {
  const nav = useNavigate({ from: "/app/shipping/carriers" });
  const list = useCarriersQuery();
  const carriers = list.data ?? [];
  const canCreate = useActionPermission(["shipping:create"]);
  const canUpdate = useActionPermission(["shipping:update"]);
  const canDelete = useActionPermission(["shipping:delete"]);
  const deleteCarrier = useDeleteCarrier();

  const handleDelete = async (id: string) => {
    toast.promise(deleteCarrier.run(id), {
      loading: "ກໍາລັງລຶບ...",
      success: "ລຶບຜູ້ຂົນສົ່ງສໍາເລັດ",
      error: "ລຶບຜູ້ຂົນສົ່ງລົ້ມເຫຼວ",
    });
  };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຜູ້ຂົນສົ່ງ" },
          ]}
        />
      </Header>
      <Main>
        <CarriersToolbar
          canManage={!!canCreate}
          onCreate={() => nav({ to: "/app/shipping/carriers/new" })}
        />
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <CarriersTable
            canEdit={!!canUpdate}
            canDelete={!!canDelete}
            data={carriers}
            isLoading={list.isLoading}
            onEdit={(row) =>
              nav({
                to: "/app/shipping/carriers/$id/edit",
                params: { id: row.id },
              })
            }
            onDelete={handleDelete}
          />
        </div>
      </Main>
    </>
  );
}
